export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SimpleGallery.vue?vue&type=template&id=f1acc0de"


//////////////////
// WEBPACK FOOTER
// ./src/components/Outputs/Images/SimpleGallery.vue?vue&type=template&id=f1acc0de
// module id = 1381
// module chunks = 31